<template>
  <div>
    <a :href="url">
      <img v-if="img" :src="img" class="ad-image" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'AdWells',
  components: {},
  data() {
    return {};
  },
  props: {
    url: String,
    img: String,
  },
};
</script>

<style lang="scss" scoped>
.ad-image {
  width: 300px;
  max-width: 100%;
  height: auto;
  margin: 2rem auto;
  display: block;
}
</style>
